import BlockSettings from "app/blocks/models/block-settings.interface";

export default (settings: BlockSettings): string[] => {
    const classes = [];

    if (settings?.backgroundColor?.color) {
        const bgColor = settings.backgroundColor.color.startsWith("#") ? settings.backgroundColor.color.substring(1) : settings.backgroundColor.color;
        classes.push(`bgcolor-${bgColor}`);
    }

    if (settings?.textColor?.color) {
        const textColor = settings.textColor.color.startsWith("#") ? settings.textColor.color.substring(1) : settings.textColor.color;
        classes.push(`textcolor-${textColor}`);
    }

    if (settings?.spacingTop) {
        classes.push(`spacing-top--${settings.spacingTop}`);
    } else {
        classes.push("spacing-top--Medium");
    }

    if (settings?.spacingBottom) {
        classes.push(`spacing-bottom--${settings.spacingBottom}`);
    } else {
        classes.push("spacing-bottom--Medium");
    }

    if (settings?.borderTop && settings.borderBottom) {
        classes.push("border-both");
    } else if (settings?.borderTop) {
        classes.push("border-top");
    } else if (settings?.borderBottom) {
        classes.push("border-bottom");
    }

    return classes;
};
